/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import SectorEnum from 'astro/enum/sector';
import Zone from 'astro/fake/builder/zone';

import * as User from 'astro/value/user';
import * as Energy from 'astro/value/energy';


export default class
{
  constructor (id, name, parent)
  {
    this.parent = parent;
    this.sector = { id, name, type: SectorEnum.Planet, user: User.getAncient() };

    this.zones = [];
  }


  createZone (coords)
  {
    const zone = new Zone(coords, this);

    this.zones.push(zone);

    return zone;
  }


  assignUser (user)
  {
    this.sector.user = user.getID();

    for (const zone of this.zones)
    {
      zone.assignEnergy([ [ user, 100 ] ]);
      zone.setUser(user.getID());
    }

    this.parent.createLocalUser(user);
  }


  setGalaxy (galaxy)
  {
    this.sector.galaxy = galaxy;

    for (const zone of this.zones)
    {
      zone.setGalaxy(galaxy);
    }
  }


  setPlanet (planet)
  {
    this.sector.planet = planet;

    for (const zone of this.zones)
    {
      zone.setPlanet(planet);
    }
  }


  setUpdateDate (date)
  {
    this.sector.update_date = date;

    for (const zone of this.zones)
    {
      zone.setUpdateDate(date);
    }
  }


  finalize ()
  {
    this.sector.zones = [];

    for (const zone of this.zones)
    {
      this.sector.zones.push(zone.getType());
    }

    this.sector.center = this.sector.zones[0].coords;
  }


  getZones ()
  {
    return this.zones;
  }


  getZone (index)
  {
    return this.zones[index];
  }


  getParent ()
  {
    return this.parent;
  }


  getType ()
  {
    return this.sector;
  }


  getID ()
  {
    return this.sector.id;
  }


  getUserID ()
  {
    return this.sector.user;
  }


  __getGalaxy__ ()
  {
    return this.parent.getParent();
  }


}
